import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const BookPriceEditor = ({ auth }) => {
  const [price, setPrice] = useState("");
  useEffect(() => { api.get("/books/price").then((r) => setPrice(String(r.data.price))); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("/admin/books/price", { price: Number(price) }, auth);
      setPrice(String(data.price));
      toast.success(`Starting price updated to $${data.price}`);
    } catch {
      toast.error("Could not update price.");
    }
  };

  return (
    <form onSubmit={save} className="flex items-end gap-3" data-testid="book-price-editor">
      <label className="block">
        <span className="overline block mb-2" style={{ color: "var(--navy)" }}>Starting price ($)</span>
        <input type="number" min="1" step="0.01" required value={price} onChange={(e) => setPrice(e.target.value)}
          className="w-32 rounded-lg bg-white px-3 py-2 font-body text-sm border outline-none" style={{ borderColor: "rgba(11,27,61,0.2)", color: "var(--navy)" }} data-testid="book-price-input" />
      </label>
      <button type="submit" className="px-5 py-2.5 rounded-full text-xs font-body text-white" style={{ backgroundColor: "var(--navy)" }} data-testid="book-price-save">Save price</button>
    </form>
  );
};
